export default __webpack_public_path__ + "static/media/starYellow.1d71f11a.svg";